import React from "react";
import { Card, Text, Tooltip } from "components";

/* Illustrative-only tiles — a teaser for the future originals library (§10). */
const PLACEHOLDER_TILES = [
  { tag: "Office", name: "Team Quiz Pack", meta: "3 rounds · 65 clues" },
  { tag: "Holiday", name: "Holiday Mixer", meta: "2 rounds · 40 clues" },
  { tag: "Classroom", name: "Classroom Starter", meta: "1 round · 25 clues" },
  { tag: "Friends", name: "Movie Night", meta: "3 rounds · 91 clues" },
];

/**
 * Pre-crafted games strip (PRD §10 placeholder): visually present, muted, and
 * non-functional, with a "coming soon" tooltip on hover.
 */
const PrecraftedStrip = () => (
  <section className="da-precrafted">
    <div className="da-section-head">
      <div>
        <Text variant="h3">Play a pre-crafted game</Text>
        <Text variant="caption" tone="muted">
          Finished games, ready to launch as-is or remix.
        </Text>
      </div>
    </div>
    <Tooltip title="A library of pre-crafted games is on the way">
      <div className="da-precrafted-grid" aria-disabled="true">
        {PLACEHOLDER_TILES.map((t) => (
          <Card key={t.name} padding="md" className="da-tpl">
            <Text variant="eyebrow" tone="accent" className="da-tpl-tag">
              {t.tag}
            </Text>
            <Text variant="h3" className="da-tpl-title">
              {t.name}
            </Text>
            <Text variant="caption" tone="muted">
              {t.meta}
            </Text>
          </Card>
        ))}
      </div>
    </Tooltip>
  </section>
);

export default PrecraftedStrip;
